import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios';
Vue.prototype.$axios = axios;

Vue.use(ElementUI);

Vue.config.productionTip = false

const currentURL = window.location.href;
const parameterMatch = currentURL.match(/\?(.*)/);

if (parameterMatch) {
  const queryString = parameterMatch[1];
  const parts = queryString.split('=');
  let str = parts[1].slice(0, -2);
  if(parts && parts.includes('token')){
    if(str){
      localStorage.setItem('token_store',str)
      setTimeout(() => {
        // window.location.href='http://xhcooks.hnbake.com/#/store_info'
        window.location.href='http://store.bgjtsvip.com/#/store_info'
      }, 500);
    }
  }
}


new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')

